"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompatibilityContentFormat = exports.CompareCategory = exports.CompatibilitySnippetType = void 0;
var CompatibilitySnippetType;
(function (CompatibilitySnippetType) {
    CompatibilitySnippetType["comparisonList"] = "comparisonList";
    // compatibilityVennDiagram = "compatibilityVennDiagram",
    CompatibilitySnippetType["spectrums"] = "spectrums";
    CompatibilitySnippetType["twoByTwo"] = "twoByTwo";
    CompatibilitySnippetType["rankedList"] = "rankedList";
    CompatibilitySnippetType["llmTitlesAndContent"] = "llmTitlesAndContent";
    CompatibilitySnippetType["llmList"] = "llmList";
    CompatibilitySnippetType["llmCarouselCards"] = "llmCarouselCards";
    CompatibilitySnippetType["llmHeaderedList"] = "llmHeaderedList";
    CompatibilitySnippetType["romanticCompatibilityReport"] = "romanticCompatibilityReport";
    CompatibilitySnippetType["workCompatibilityReport"] = "workCompatibilityReport";
    CompatibilitySnippetType["emojiMatch"] = "emojiMatch";
    CompatibilitySnippetType["rankedLists"] = "rankedLists";
    CompatibilitySnippetType["llmNatureStatements"] = "llmNatureStatements";
})(CompatibilitySnippetType = exports.CompatibilitySnippetType || (exports.CompatibilitySnippetType = {}));
var CompareCategory;
(function (CompareCategory) {
    CompareCategory["corePersonality"] = "corePersonality";
    CompareCategory["loveAndRelationships"] = "loveAndRelationships";
    CompareCategory["friendshipAndOutlook"] = "friendshipAndOutlook";
    CompareCategory["work"] = "work"; // Work
})(CompareCategory = exports.CompareCategory || (exports.CompareCategory = {}));
var CompatibilityContentFormat;
(function (CompatibilityContentFormat) {
    CompatibilityContentFormat["spectrum"] = "spectrum";
    CompatibilityContentFormat["twoByTwo"] = "twoByTwo";
    CompatibilityContentFormat["traitTile"] = "traitTile";
})(CompatibilityContentFormat = exports.CompatibilityContentFormat || (exports.CompatibilityContentFormat = {}));
